import React from "react";
import { motion } from "framer-motion";

const data = [
  {
    id: 1,
    title: "The 24/7 Elite Sanctuary",
    text: "You are never alone. A synchronized team of 9 medical experts—from Gynecologists to Nutritionists to Mental Health Coaches—surrounds you from Day 1. Convenience is our clinical standard: no more 2 AM Google searches, rushed 10-minute clinic visits, or long waiting hours. Your cohesive, integrated medical family is right in your pocket, ready to treat, answer, guide, and reassure—anytime, anywhere.",
    img: "/beyond1.png",
    top: "15%",
    right: "10%",
    flexDir: "row-reverse",
    slideFrom: 150 
  },
  {
    id: 2,
    title: "The AI Command Center",
    text: "Your health doesn't sleep, and neither does our technology. Our AI-driven tracker monitors your vitals daily, detecting risks like GDM or Hypertension before they become complications. With total transparency at your fingertips, your entire 9-month journey—from consults to lab reports to every penny spent—is managed through India’s first end-to-end pregnancy platform. Complete control. Zero stress.",
    img: "/beyond2.png",
    top: "38%",
    left: "10%",
    flexDir: "row",
    slideFrom: -150 
  },
  {
    id: 3,
    title: "The Holistic & Transparent Blueprint",
    text: "We care for the woman, not just the patient. Daily engagement with your medical team, who monitor your progress and provide tailored advice 24/7, isn't a luxury—it's our standard. With live Yoga, personalized Diet plans, Garbhasanskar, and Emotional Wellness coaching, experience complete care under one roof at a transparent, affordable price with absolutely no hidden costs.",
    img: "/beyond3.png",
    top: "60%",
    right: "12%",
    flexDir: "row-reverse",
    slideFrom: 150
  },
  {
    id: 4,
    title: "The Ultimate Transformation",
    text: "We don't just deliver babies; we turn every day of your pregnancy into a celebration. Experience a journey that is physically safe, emotionally healthy, and beautifully organized.",
    img: "/beyond4.png",
    top: "82%",
    left: "15%",
    flexDir: "row",
    slideFrom: -150
  },
];

const BeyondClinic = () => {
  return (
    <>

      <section className="beyond-section">
        <img src="/Beyondtop.png" className="top-edge" alt="" />
        <div className="beyond-header">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ amount: 0.5 }}
          >
           <h2>
             Beyond the <span className="pink-text">Clinic</span>. Beyond the <br />
             <span className="pink-text">Ordinary</span>
           </h2>
           <p>
             While hospitals focus on the delivery, Myprega focuses on you—every single hour, for all nine 
             months. This is how we’ve reimagined motherhood for the modern woman.
           </p>
          </motion.div>
        </div>

        <div className="road-wrapper">
          {data.map((item) => (
            <motion.div 
              key={item.id} 
              className="road-item" 
              style={{ 
                top: item.top, 
                left: item.left || 'auto', 
                right: item.right || 'auto',
                flexDirection: item.flexDir 
              }}
              
              initial={{ opacity: 0, x: item.slideFrom }} 
              whileInView={{ opacity: 1, x: 0 }} 
              viewport={{ amount: 0.3 }} 
              transition={{ duration: 0.7, ease: "easeOut" }}
            >
              <img src={item.img} alt={item.title} />
              <div className="item-text">
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            </motion.div>
          ))}
        </div>
        <img src="/BeyondbottoM.png" className="bottom-edge" alt="" />
      </section>
    </>
  );
};

export default BeyondClinic;
